export default "__VITE_ASSET__9EtCH5PR__"